module.exports = __webpack_public_path__ + "static/Zam@2x.728096b2.png";